@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  /* Dark theme - profissional para OSINT */
  --background: #0f1419;
  --foreground: #e0e7ff;
  --muted: #4b5563;
  --muted-foreground: #9ca3af;

  /* Primary: Blue */
  --primary: #3b82f6;
  --primary-dark: #1e40af;

  /* Success: Green */
  --success: #10b981;

  /* Warning: Amber */
  --warning: #f59e0b;

  /* Destructive: Red */
  --destructive: #ef4444;

  /* Border */
  --border: #1e293b;

  /* Shadow elegante */
  --shadow: rgba(0, 0, 0, 0.5) 0 10px 25px -5px;

  color-scheme: dark;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  background-color: var(--background);
  color: var(--foreground);
}

#root {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

